import { Fragment, useState } from "react"
import { Transition } from "@headlessui/react"
import { CheckCircleIcon, PlayIcon } from "@heroicons/react/outline"
import { XIcon } from "@heroicons/react/solid"

import Button from "./Button"
import ColorShimImage from "./ColorShimImage"

export type NotificationVariant = "success" | "error" | "warning"

export interface Notification {
	message: string
	variant?: NotificationVariant
}

function HonestNotification({
	notification,
	showNotification = false,
}: {
	showNotification?: boolean
	notification: Notification
}) {
	const [show, setShow] = useState(true)

	if (notification?.message) console.info({ notification })

	if (!showNotification) return null

	return (
		<>
			{/* Global notification live region, render this permanently at the end of the document */}
			<div
				aria-live="assertive"
				className="fixed inset-0 bottom-0 right-0 z-50 items-end hidden px-4 py-6 pointer-events-none 2xl:flex sm:p-6 sm:items-start"
			>
				<div className="flex flex-col items-center w-full space-y-4 sm:items-end">
					{/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
					{(showNotification || show) && (
						<Transition
							show={show}
							as={Fragment}
							enter="transform ease-out duration-300 transition"
							enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
							enterTo="translate-y-0 opacity-100 sm:translate-x-0"
							leave="transition ease-in duration-100"
							leaveFrom="opacity-100"
							leaveTo="opacity-0"
						>
							<div className="relative flex justify-center w-full max-w-xs px-2 pt-5 pb-1 overflow-hidden text-center bg-pink-400 border-4 shadow-lg pointer-events-auto text-farm-black border-farm-yellow rounded-3xl ring-1 ring-black ring-opacity-5">
								<a
									href="https://docs.farmernft.com/howdygames/howdy-games/locations/wedding-location"
									target="_blank"
									rel="noreferrer"
									onClick={() => setShow(false)}
								>
									<div className="w-full">
										<h2 className="text-lg font-black text-white lg:text-3xl text-h2">
											Howdy Farm Girl
										</h2>
										{/* <Button
												variant="secondary"
												className="w-full px-2 py-1 mt-5"
												onClick={() => {
													setShow(false)
												}}
												>
												Harvest $🍠
											</Button> */}
										<div className="grid grid-cols-4 rounded-xl 2xl:grid-cols-2">
											<ColorShimImage
												src="/assets/girly3.png"
												width={100}
												height={100}
												rgb={[255, 236, 64]}
											/>
											<ColorShimImage
												src="/assets/girly2.png"
												width={100}
												height={100}
												rgb={[255, 236, 64]}
											/>
											<ColorShimImage
												src="/assets/girly1.png"
												width={100}
												height={100}
												rgb={[255, 236, 64]}
											/>
											<ColorShimImage
												src="/assets/girly4.png"
												width={100}
												height={100}
												rgb={[255, 236, 64]}
											/>
											<Button className="px-2 col-span-full">
												Lets get married
											</Button>
										</div>
									</div>
								</a>
							</div>
						</Transition>
					)}
				</div>
			</div>
		</>
	)
}

export default HonestNotification
